import { Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';
import { setFundChartSecurityGroup } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/security-group/security-group.actions';
import { setFundChartSecuritylistName } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/securitylist-name/security-list-name.actions';
import { setFundChartSecuritylistSecurityId } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/securitylist-security-id/security-list-security-id.actions';
import { setTechChartSecurityGroup } from 'ChartApp/ts/features/tech-chart-page-shared/state/reducers/security-group/security-group.actions';
import { setTechChartSecuritylistName } from 'ChartApp/ts/features/tech-chart-page-shared/state/reducers/securitylist-name/security-list-name.actions';
import { setTechChartSecuritylistSecurityId } from 'ChartApp/ts/features/tech-chart-page-shared/state/reducers/securitylist-security-id/securitylist-security-id.actions';
import { addSecuritiesInfo } from 'SecuritiesApp/ts/state/securities-info/securities-info.actions';
import { getAppStateSliceKey, getSecurityGroup, getSecuritylistName, getSecuritylistSecurityId, getSelectedSecuritylistItemDisplayId, } from 'ChartApp/ts/state/base-chart.selectors';
import { FUND_CHART_APP_STATE_SLICE_KEY } from 'ChartApp/ts/features/fundamental-chart/constants';
import { TECH_CHART_APP_STATE_SLICE_KEY } from 'ChartApp/ts/features/tech-chart/constants';
import { ALTERNATIVE, BENCHMARK_PORTFOLIO, BOND, CEF, CLIENT_PORTFOLIO, CUSTOM_SECURITY, ETF, GSAC_BOND, HOUSEHOLD_PORTFOLIO, INDEX, INDICATOR, MODEL_PORTFOLIO, MONEY_MARKET_FUND, MUNICIPAL_BOND, MUTUAL_FUND, REGISTRATION_PORTFOLIO, SEPARATE_ACCOUNT, STOCK, UIT, UNLISTED_CEF, } from 'NewAngular/constants/core.constants';
import { SecuritiesService } from 'SecuritiesApp/ts/services/securities.service';
import { SecurityListService } from 'SecurityListsApp/ts/services/security-list.service';
import { SecurityListMenuService } from 'SecurityListsApp/ts/services/security-list-menu.service';
import * as i0 from "@angular/core";
import * as i1 from "SecuritiesApp/ts/services/securities.service";
import * as i2 from "SecurityListsApp/ts/services/security-list-menu.service";
import * as i3 from "SecurityListsApp/ts/services/security-list.service";
import * as i4 from "@ngrx/store";
import * as i5 from "@angular/common";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
function ChartBaseListBrowserComponent_div_0_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10)(2, "div", 11)(3, "a", 12);
    i0.ɵɵlistener("click", function ChartBaseListBrowserComponent_div_0_div_9_Template_a_click_3_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.prevHandler()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 13);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "a", 14);
    i0.ɵɵlistener("click", function ChartBaseListBrowserComponent_div_0_div_9_Template_a_click_6_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.nextHandler()); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 15)(8, "span", 16);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "div", 17);
    i0.ɵɵtext(12, "Browse with RIGHT + LEFT keys");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r1.displaySecurityId);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.selectedIndex + 1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" of ", ctx_r1.securitylistSecurityIds.length, " Securities ");
} }
function ChartBaseListBrowserComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3)(3, "div", 4);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 5)(6, "a", 6);
    i0.ɵɵlistener("click", function ChartBaseListBrowserComponent_div_0_Template_a_click_6_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.removeSecuritylist()); });
    i0.ɵɵelementStart(7, "span");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(8, "svg", 7);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵtemplate(9, ChartBaseListBrowserComponent_div_0_div_9_Template, 13, 3, "div", 8);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.displaySecurityList, " ");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r1.securitylistSecurityIds.length > 0);
} }
const VALID_DETAILED_SECURITY_TYPES = [
    ALTERNATIVE,
    BENCHMARK_PORTFOLIO,
    BOND,
    CEF,
    CLIENT_PORTFOLIO,
    CUSTOM_SECURITY,
    ETF,
    GSAC_BOND,
    HOUSEHOLD_PORTFOLIO,
    INDEX,
    INDICATOR,
    MODEL_PORTFOLIO,
    MONEY_MARKET_FUND,
    MUNICIPAL_BOND,
    MUTUAL_FUND,
    REGISTRATION_PORTFOLIO,
    SEPARATE_ACCOUNT,
    STOCK,
    UIT,
    UNLISTED_CEF,
];
export class ChartBaseListBrowserComponent {
    constructor(securitiesService, securityListMenuService, securityListService, store) {
        this.securitiesService = securitiesService;
        this.securityListMenuService = securityListMenuService;
        this.securityListService = securityListService;
        this.store = store;
        this.displaySecurityId = '';
        this.securitylistName = '';
        this.securitylistSecurityId = '';
        this.securitylistSecurityIds = [];
        this.selectedIndex = 0;
        this.isAlive = true;
        this.securityInfoFetchSubscription = null;
        this.mapStateToComponent = (state) => {
            this.appStateSliceKey = getAppStateSliceKey(state);
            const { securitiesInfo } = state;
            const securityGroup = getSecurityGroup(state);
            this.displaySecurityId = getSelectedSecuritylistItemDisplayId(state);
            const prevSecuritylistSecurityId = this.securitylistSecurityId;
            this.securitylistSecurityId = getSecuritylistSecurityId(state);
            const prevSecuritylistName = this.securitylistName;
            this.securitylistName = getSecuritylistName(state);
            if (!this.securitylistName) {
                this.securitylistSecurityIds = [];
            }
            if (this.securitylistMenuLabelMap?.[securityGroup]) {
                this.displaySecurityList = this.securitylistMenuLabelMap[securityGroup][this.securitylistName];
            }
            else {
                this.displaySecurityList = '';
            }
            if (this.securitylistName && prevSecuritylistName !== this.securitylistName) {
                this.securityListService
                    .getMembers(this.securitylistName, securityGroup, VALID_DETAILED_SECURITY_TYPES)
                    .subscribe((data) => {
                    this.securitylistSecurityIds = data.map((s) => s.security_id);
                    let newSecuritylistSecurityId = this.securitylistSecurityId;
                    if (data.length > 0) {
                        const validNewSecuritylistSecurityId = data.find((security) => {
                            return security.security_id === newSecuritylistSecurityId;
                        });
                        if (prevSecuritylistSecurityId || !validNewSecuritylistSecurityId) {
                            newSecuritylistSecurityId = data[0].security_id;
                        }
                        if (this.appStateSliceKey === FUND_CHART_APP_STATE_SLICE_KEY) {
                            this.store.dispatch(setFundChartSecuritylistSecurityId({
                                securitylistSecurityId: newSecuritylistSecurityId,
                            }));
                        }
                        else if (this.appStateSliceKey === TECH_CHART_APP_STATE_SLICE_KEY) {
                            this.store.dispatch(setTechChartSecuritylistSecurityId({
                                securitylistSecurityId: newSecuritylistSecurityId,
                            }));
                        }
                    }
                    this.selectedIndex = this.securitylistSecurityIds.indexOf(newSecuritylistSecurityId);
                });
            }
            if (this.securitylistSecurityId && !securitiesInfo[this.securitylistSecurityId]) {
                if (this.securityInfoFetchSubscription !== null) {
                    this.securityInfoFetchSubscription.unsubscribe();
                }
                this.securityInfoFetchSubscription = this.securitiesService
                    .getSecuritiesInfo(this.securitylistSecurityId)
                    .subscribe((_data) => {
                    const validSecurityId = _data.find((security) => {
                        return security.id === this.securitylistSecurityId;
                    });
                    // if security is missing from the response, it does not exist
                    // or the user does not have access to it
                    if (!validSecurityId) {
                        this.nextHandler();
                    }
                    this.store.dispatch(addSecuritiesInfo({ securitiesInfo: _data }));
                });
            }
        };
        this.store
            .select('reducers')
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(this.mapStateToComponent);
    }
    ngOnInit() {
        this.securityListMenuService
            .getLabels()
            .pipe(takeWhile(() => this.isAlive))
            .subscribe((securitylistMenuLabelMap) => {
            this.securitylistMenuLabelMap = securitylistMenuLabelMap;
        });
    }
    ngOnDestroy() {
        this.isAlive = false;
        if (this.securityInfoFetchSubscription !== null) {
            this.securityInfoFetchSubscription.unsubscribe();
        }
    }
    handleKeyboardEvent(event) {
        // If the element is an input element then ignore it because
        // we don't want to respond to left and right arrows within
        // a text input box.
        if (ChartBaseListBrowserComponent.isInputElement(event.target)) {
            return;
        }
        if (event.code === 'ArrowLeft') {
            this.prevHandler();
        }
        else if (event.code === 'ArrowRight') {
            this.nextHandler();
        }
    }
    /**
     * Check if the given element is an input element.
     *
     * @private
     * @param element
     * @type HTMLElement
     *
     * @return boolean
     */
    static isInputElement(element) {
        return element && element.tagName === 'INPUT';
    }
    removeSecuritylist() {
        if (this.appStateSliceKey === FUND_CHART_APP_STATE_SLICE_KEY) {
            this.store.dispatch(setFundChartSecuritylistName({ securitylistName: '' }));
            this.store.dispatch(setFundChartSecurityGroup({ securityGroup: '' }));
            this.store.dispatch(setFundChartSecuritylistSecurityId({ securitylistSecurityId: '' }));
        }
        else if (this.appStateSliceKey === TECH_CHART_APP_STATE_SLICE_KEY) {
            this.store.dispatch(setTechChartSecuritylistName({ securitylistName: '' }));
            this.store.dispatch(setTechChartSecurityGroup({ securityGroup: '' }));
            this.store.dispatch(setTechChartSecuritylistSecurityId({ securitylistSecurityId: '' }));
        }
    }
    prevHandler() {
        if (this.securitylistSecurityIds.length === 0) {
            return;
        }
        if (this.selectedIndex === 0) {
            this.selectedIndex = this.securitylistSecurityIds.length - 1;
        }
        else {
            this.selectedIndex -= 1;
        }
        const securityId = this.securitylistSecurityIds[this.selectedIndex];
        if (this.appStateSliceKey === FUND_CHART_APP_STATE_SLICE_KEY) {
            this.store.dispatch(setFundChartSecuritylistSecurityId({ securitylistSecurityId: securityId }));
        }
        else if (this.appStateSliceKey === TECH_CHART_APP_STATE_SLICE_KEY) {
            this.store.dispatch(setTechChartSecuritylistSecurityId({ securitylistSecurityId: securityId }));
        }
    }
    nextHandler() {
        if (this.securitylistSecurityIds.length === 0) {
            return;
        }
        if (this.selectedIndex === this.securitylistSecurityIds.length - 1) {
            this.selectedIndex = 0;
        }
        else {
            this.selectedIndex += 1;
        }
        const securityId = this.securitylistSecurityIds[this.selectedIndex];
        if (this.appStateSliceKey === FUND_CHART_APP_STATE_SLICE_KEY) {
            this.store.dispatch(setFundChartSecuritylistSecurityId({ securitylistSecurityId: securityId }));
        }
        else if (this.appStateSliceKey === TECH_CHART_APP_STATE_SLICE_KEY) {
            this.store.dispatch(setTechChartSecuritylistSecurityId({ securitylistSecurityId: securityId }));
        }
    }
}
ChartBaseListBrowserComponent.ɵfac = function ChartBaseListBrowserComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ChartBaseListBrowserComponent)(i0.ɵɵdirectiveInject(i1.SecuritiesService), i0.ɵɵdirectiveInject(i2.SecurityListMenuService), i0.ɵɵdirectiveInject(i3.SecurityListService), i0.ɵɵdirectiveInject(i4.Store)); };
ChartBaseListBrowserComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ChartBaseListBrowserComponent, selectors: [["ycn-chart-base-list-browser"]], hostBindings: function ChartBaseListBrowserComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("keydown.ArrowLeft", function ChartBaseListBrowserComponent_keydown_ArrowLeft_HostBindingHandler($event) { return ctx.handleKeyboardEvent($event); }, i0.ɵɵresolveDocument)("keydown.ArrowRight", function ChartBaseListBrowserComponent_keydown_ArrowRight_HostBindingHandler($event) { return ctx.handleKeyboardEvent($event); }, i0.ɵɵresolveDocument);
    } }, standalone: false, decls: 1, vars: 1, consts: [["class", "options-list user-select-none", 4, "ngIf"], [1, "options-list", "user-select-none"], [1, "options-list-item"], [1, "options-list-item-header"], [1, "options-list-item-title"], [1, "options-list-item-controls"], ["ycnTooltip", "", "tooltipTitle", "Remove", "tooltipPlacement", "bottom", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-close", 3, "click"], ["ycnIcon", "", "name", "icon-close"], ["class", "options-list-item-body", 4, "ngIf"], [1, "options-list-item-body"], [1, "form-row", "form-inline"], ["tabindex", "0", 1, "btn-group"], [1, "btn", "btn-secondary", "arrow-left", 3, "click"], [1, "form-control"], [1, "btn", "btn-secondary", "arrow-right", 3, "click"], [1, "form-label"], [1, "text-primary"], [1, "form-direction"]], template: function ChartBaseListBrowserComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ChartBaseListBrowserComponent_div_0_Template, 10, 2, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.displaySecurityList);
    } }, dependencies: [i5.NgIf, i6.IconDirective, i7.TooltipDirective], encapsulation: 2 });
